/**
 * 巡检管理（inspectionManagement）模块英文映射 · 第 2 组（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/inspectionManagement/ 下 ProblemManagementOutsourcing、
 * ProblemManagementRevenue、ProblemManagementWaterWorks 三个目录（问题确认/问题处理/
 * 问题记录/问题上报 及其 HandleModal、ConfirmModal、ConfirmIsOrderModal、
 * rejectAndStopModal、AddProblemModal 弹窗与 index 页签容器）
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并；
 * 通用词（确定/取消/关闭/提示/查询/重置/编辑/删除/详情/操作/创建时间/是/否 等）复用 en-US.js，不重复收录
 */
export default {
  // ── 业务名词 ──
  '问题确认': 'Problem Confirmation',
  '问题处理': 'Problem Handling',
  '问题记录': 'Problem Records',
  '问题上报': 'Problem Reporting',
  '问题详情': 'Problem Details',
  '问题等级': 'Problem Level',
  '问题描述': 'Problem Description',
  '上报人': 'Reporter',
  '上报人电话': 'Reporter Phone',
  '现场坐标': 'On-site Coordinates',
  '现场图片或视频': 'On-site Photos or Videos',
  '检测实体': 'Detected Entity',
  '关联工单': 'Related Work Order',
  '状态': 'Status',
  '未确认': 'Unconfirmed',
  '已确认': 'Confirmed',
  '驳回': 'Reject',
  '搁置': 'On Hold',
  '已完成': 'Completed',
  '工单处理中': 'Work Order Processing',
  '处理人': 'Handler',
  '处理时间': 'Handling Time',
  '是否现场已解决': 'Resolved On Site',
  '已解决': 'Resolved',
  '未解决': 'Unresolved',
  '确认信息': 'Confirmation Info',
  '确认人': 'Confirmer',
  '确认描述': 'Confirmation Description',
  '处理': 'Handle',
  '审批描述': 'Approval Description',
  '处理信息': 'Handling Info',
  '处理图片': 'Handling Photos',
  '处理描述': 'Handling Description',
  '处理前图片或视频': 'Photos/Videos Before Handling',
  '处理后图片或视频': 'Photos/Videos After Handling',
  '驳回信息': 'Rejection Info',
  '驳回时间': 'Rejection Time',
  '驳回原因': 'Rejection Reason',
  '搁置信息': 'On-hold Info',
  '搁置时间': 'On-hold Time',
  '搁置原因': 'On-hold Reason',
  '驳回成功！': 'Rejected successfully!',
  '搁置成功！': 'Put on hold successfully!',
  '生成工单成功！': 'Work order created successfully!',
  '普通处理界面': 'Normal Handling Interface',
  '预览': 'Preview',
  '上传': 'Upload',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '时间范围': 'Time Range',
  '设备编号': 'Device No.',
  '设备名称': 'Device Name',
  '设备类型': 'Device Type',
  '地理信息': 'Geographic Info',

  // ── 工单相关（确认时可生成报修工单）──
  '是否开启工单': 'Create Work Order or Not',
  '工单类型': 'Work Order Type',
  '故障报修': 'Fault Repair',
  '水厂报修': 'Water Plant Repair',
  '工单联系人': 'Work Order Contact',
  '联系电话': 'Contact Phone',
  '紧急程度': 'Urgency',
  '预约时间': 'Appointment Time',

  // ── 提示语 ──
  '请选择设备类型': 'Please select device type',
  '请选择问题等级': 'Select problem level',
  '请选择状态': 'Select status',
  '请选择是否开启工单': 'Please select whether to create a work order',
  '请选择工单类型': 'Please select work order type',
  '请输入工单联系人': 'Please enter work order contact',
  '请输入联系电话': 'Please enter contact phone',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请输入工单位置': 'Please enter work order location',
  '请选择紧急程度': 'Please select urgency',
  '请选择处理人': 'Please select handler',
  '请输入审批描述': 'Please enter approval description',
  '请选择处理照片': 'Please select handling photos',
  '请输入处理描述': 'Please enter handling description',
  '请输入驳回原因': 'Please enter rejection reason',
  '请输入搁置原因': 'Please enter on-hold reason',
  '请输入回复内容': 'Please enter reply content',
}
